export const DISABLED_ON_MOBILE_MAP = {
  student_receive_document: true,
  to_do_due_this_week: false,
  to_do_due_tomorrow: false,
  college_app_due_this_week: true,
  college_app_due_tomorrow: true,
  scholarship_app_due_this_week: false,
  scholarship_app_due_tomorrow: false,
  ilp_reminder: true,
};

export default {
  student_receive_document: () => '/document-center',
  to_do_due_this_week: () => '/dashboard/student',
  to_do_due_tomorrow: () => '/dashboard/student',
  college_app_due_this_week: ({ schoolId, applicationUuid }) =>
    `/college-applications/app/${schoolId}/${applicationUuid}`,
  college_app_due_tomorrow: ({ schoolId, applicationUuid }) =>
    `/college-applications/app/${schoolId}/${applicationUuid}`,
  scholarship_app_due_this_week: () => '/scholarships',
  scholarship_app_due_tomorrow: () => '/scholarships',
  ilp_reminder: () => '/plans/overview',
};
